import {SearchBar, Select} from '@/components';
import {doNothing, getCountryOptions} from '@/constants/formatters';
import {useCountryList} from '@/context/CountryListContext';
import type {AfriexQueryParams} from '@/types';
import {AfriexTransactionChannel} from '@/types';
import {mapCountryListToOptions} from '@/utils/countries';

// The four values `useBlockedPaymentMethod` hands down through
// `Blocked/PaymentMethods/index.tsx`.
type BlockedPaymentMethodFiltersProps = {
  currentFilters: AfriexQueryParams;
  clearFilters: () => void;
  handleSearch: (searchTerm: string) => Promise<void>;
  selectCurrentFilters: (
    name: string,
    value: string | Date | undefined,
  ) => void;
};

const BlockedPaymentMethodFilters = ({
  currentFilters,
  clearFilters,
  handleSearch,
  selectCurrentFilters,
}: BlockedPaymentMethodFiltersProps) => {
  const {state: countryListState} = useCountryList();
  const {countryList} = countryListState;
  const countryOptions = mapCountryListToOptions(countryList || []);

  return (
    <div className="mt-5 w-full">
      <div className="flex flex-col md:flex-row md:items-center gap-4 justify-between">
        {/* Search Bar */}
        <SearchBar
          handleSearch={handleSearch}
          handleAutoComplete={doNothing}
          placeholder="Search by account or card number"
          clearFilters={clearFilters}
          inputClassName="w-full md:w-2/5"
        />

        <div className="flex justify-end flex-col md:flex-row mt-3 md:mt-0 gap-3 md:items-center md:space-x-3">
          {/* Country and channel Select Boxes */}
          <Select
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
              selectCurrentFilters('country', e.target.value)
            }
            value={currentFilters.country}
            name="country"
            options={getCountryOptions(countryOptions)}
            placeholder="Filter by Country"
            className="w-1/2"
          />

          <Select
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
              selectCurrentFilters('type', e.target.value)
            }
            value={currentFilters.type}
            name="type"
            options={[
              {key: 'Debit Card', value: AfriexTransactionChannel.CARD},
              {
                key: 'Bank Account',
                value: AfriexTransactionChannel.BANK_ACCOUNT,
              },
              {
                key: 'Mobile Money Wallet',
                value: AfriexTransactionChannel.MOBILE_MONEY,
              },
            ]}
            placeholder="Filter by Type"
            className="w-fit"
          />
        </div>
      </div>
    </div>
  );
};

export default BlockedPaymentMethodFilters;
